import React from 'react';
import { useAuth } from '@/modules/auth/hooks/use-auth';

const Logout = () => {
    const { logout } = useAuth();

    const handleLogout = async (event: React.MouseEvent) => {
        event.preventDefault();
        await logout();
    };

    return (
        <button
            onClick={handleLogout}
            style={{
                background: 'none',
                border: 'none',
                padding: 0,
                font: 'inherit',
                color: 'inherit',
                cursor: 'pointer',
                textDecoration: 'underline'
            }}
        >
            Logout
        </button>
    );
};

export default Logout;